import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { fetchApi } from '@inmagik/react-crud'
import { Field, Formik, getIn } from 'formik'
import { API_URL } from '../constants'
import { Link } from 'react-router-dom'
import yup from '../utils/validations'

const schema = yup.object().shape({
  email: yup.string().email().required().label('Email'),
})

const initialValues = {
  email: '',
}

export function PasswordDimenticata() {
  const [confirm, setConfirm] = useState(false)
  return (
    <div className="d-flex h-100 bg-primary guest-page">
      <div className="w-50 bg-primary h-100 d-flex flex-column justify-content-center align-items-center guest-brand">
        <img
          src="/statik/main/LOGO.svg"
          height={40}
          alt=""
          className="d-block mb-2 me-2"
          onError={(e) => {
            ;(e.target as HTMLImageElement).style.display = 'none'
          }}
        />
      </div>
      <div
        className="w-50 d-flex flex-column justify-content-center align-items-center bg-white guest-panel"
        style={{
          borderRadius: '20px 0 0 20px',
        }}
      >
        <div className="w-50 guest-content">
          <h1 className="heading-h1">PASSWORD DIMENTICATA</h1>
          <div className="p-medium">
            Inserisci il tuo indirizzo email e ti invieremo le istruzioni per
            recuperare la password.
          </div>
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            enableReinitialize
            onSubmit={async (values) => {
              await fetchApi(API_URL + '/utenti/users/recover_password/', {
                method: 'POST',
                body: JSON.stringify(values),
                headers: {
                  'Content-Type': 'application/json',
                },
              }).then((e) => {
                setConfirm(true)
              })
            }}
          >
            {({ handleSubmit, touched, errors }) => (
              <form onSubmit={handleSubmit}>
                <div className="mt-2">
                  <div className="form-group">
                    <label
                      htmlFor="email"
                      className="label-m text-body-secondary"
                    >
                      Email
                    </label>
                    <Field
                      name="email"
                      type="email"
                      autoComplete="email"
                      autoCapitalize="none"
                      className={
                        'form-control' +
                        (getIn(errors, 'email') && getIn(touched, 'email')
                          ? ' is-invalid'
                          : '')
                      }
                    />

                    {getIn(errors, 'email') && getIn(touched, 'email') && (
                      <div className="text-danger">
                        {getIn(errors, 'email')}
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  {confirm && (
                    <div className="alert alert-success mt-2 py-1">
                      Ti è stata inviata una email con le istruzioni per
                      recuperare la password. Vai al{' '}
                      <Link to="/login">login</Link>
                    </div>
                  )}
                </div>

                <Button
                  type="submit"
                  variant="secondary"
                  className="w-100 mt-2 text-white"
                >
                  Recupera password
                </Button>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
